(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gdm-c-pager"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gdm-c-load-more')) {
    class GdmCLoadMore extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const link = event.target instanceof Element ? event.target.closest('[data-gdm-more]') : null;
          if (!link) return;
          event.preventDefault();
          this.load(link);
        });
      }

      async load(link) {
        const grid = document.querySelector('.main-collection-grid .product-grid');
        if (!grid || link.getAttribute('aria-busy') === 'true') {
          window.location.href = link.href;
          return;
        }
        link.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(link.href, { credentials: 'same-origin' });
          if (!response.ok) throw new Error(String(response.status));
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = doc.querySelectorAll('.main-collection-grid .product-grid > .product-grid__item');
          if (!items.length) throw new Error('empty');
          items.forEach((item) => grid.appendChild(document.importNode(item, true)));
          const next = doc.querySelector('gdm-c-load-more');
          if (next) {
            this.innerHTML = next.innerHTML;
          } else {
            this.remove();
          }
          const nav = document.querySelector('.main-collection-grid nav.pagination');
          const nextNav = doc.querySelector('.main-collection-grid nav.pagination');
          if (nav && nextNav) nav.replaceWith(document.importNode(nextNav, true));
        } catch (error) {
          window.location.href = link.href;
        }
      }
    }

    customElements.define('gdm-c-load-more', GdmCLoadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
